import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { AdvertisementService } from 'src/app/core/services/advertisement.service';
import { AudioPreviewWrapperComponent } from '../../material-detail/audio-preview-wrapper/audio-preview-wrapper.component';
import { VideoPreviewWrapperComponent } from '../../material-detail/video-preview-wrapper/video-preview-wrapper.component';
import { PublicationPreviewWrapperComponent } from '../../material-detail/publication-preview-wrapper/publication-preview-wrapper.component';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { RenewContentComponent } from '../renew-content/renew-content.component';
import { Router, NavigationExtras } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-playlist-detail-modal',
  templateUrl: './playlist-detail-modal.component.html',
  styleUrls: ['./playlist-detail-modal.component.scss']
})
export class PlaylistDetailModalComponent implements OnInit {

  @Input() public collection;
  imagePath = environment.url;
  userData;
  isPreview = false;
  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private authService: AuthService,
    private _spinner: NgxSpinnerService,
    private router: Router,
    private _advertisementService: AdvertisementService
  ) { }

  ngOnInit() {
    this.collection.contents.forEach(c => {
      const title = this.generatePopOverData(c).title;
      const message = this.generatePopOverData(c).message;
      c.popover_title = title;
      c.popover_message = message;
      if (c.purchase_content_before_paid_lib_subscribe && c.content_deteled_by_owner && !c.paid_library_subscription_expired) {
        c.content_deteled_by_owner = false;
      }
    });
    this.userData = this.authService.getCurrentUser();
  }

  closeDialog() {
    this.activeModal.close();
  }

  openPreview(data, previewType) {
    if ((data.grace_and_grayed || this.collection.purchasable || (data.visibility == 'grayed' && this.userData.user.id !== data.user_id && data.tokens <= 0) || (data.content_relationship.visibility == 'disable')) || data.grace_and_grayed || (data.paid_library_subscription_expired && !data.purchase_content_before_paid_lib_subscribe && data.tokens > 0) || data.content_deteled_by_owner) {

      if (!this.collection.purchasable && ((data.paid_library_subscription_expired && !data.purchase_content_before_paid_lib_subscribe && data.tokens > 0 && !data.user_plan_expired) && data.user.verification && data.user.verification.is_verified != 'rejected' && data.creator_library_type == 'public')) {
        const modalRef = this.modalService.open(RenewContentComponent, { centered: true });
        modalRef.componentInstance.currentUser = data.user;
        modalRef.result.then((result) => {
          if (result == 'renew-subscription') {
            this.closeDialog();
            const navigationExtras: NavigationExtras = {
              queryParams: {
                source: 'subscriptionModal',
                user_id: data.user.id
              }
            };
            this.router.navigate(['/other-profile', data.user.id], navigationExtras);
          }
          if (result == 'buy-individual') {
            this.closeDialog();
            const navExtras: NavigationExtras = {
              queryParams: {
                buy_individual: "true",
              }
            }
            this.router.navigate(['/material-detail-page', data.id], navExtras);
          }
        });
      }

      return;
    }
    let materialAd;
    if (!this.isPreview) {
      this.isPreview = true;
      this._spinner.show();
      this._advertisementService.loadMaterialAds(data.id).subscribe(
        (response: any) => {
          if (response.success && response.data.advertisement) {
            materialAd = response.data.advertisement;
          } else {
            materialAd = false;
          }
          this._spinner.hide();
          this.openFinalPreview(data, previewType, materialAd);
        },
        (error: any) => {
          this._spinner.hide();
          materialAd = false;
          this.openFinalPreview(data, previewType, materialAd);
        }
      )
    }

  }

  openFinalPreview(data, previewType, materialAd) {
    var modalRef;
    if (data.content_type == 'audio')
      modalRef = this.modalService.open(AudioPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'audio-modal', backdrop: 'static', keyboard: false });
    else if (data.content_type == 'video')
      modalRef = this.modalService.open(VideoPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'video-modal', backdrop: 'static', keyboard: false });
    else if (data.content_type == 'document')
      modalRef = this.modalService.open(PublicationPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'pdf-modal', backdrop: 'static', keyboard: false });
    if (previewType === 'view') {
      const thumbnail = (data.links_cloud && data.links_cloud.thumbnail) ? data.links_cloud.thumbnail : API_ENDPOINTS.BASE_URL + data.thumb;
      if (materialAd != false) {
        modalRef.componentInstance.isAdvertisement = true;
        modalRef.componentInstance.materialAd = materialAd;
      }
      else {
        modalRef.componentInstance.isAdvertisement = false;
      }
      if (data.content_type == 'document')
        modalRef.componentInstance.url = data.link;
      modalRef.componentInstance.thumbnail = thumbnail;
      modalRef.componentInstance.content = data;
      modalRef.componentInstance.preview = false;
    } else if (previewType === 'preview') {
      const thumbnail = (data.preview_link && data.preview_link.thumbnail) ? data.preview_link.thumbnail : API_ENDPOINTS.BASE_URL + data.thumb;
      modalRef.componentInstance.url = data.preview_link;
      modalRef.componentInstance.thumbnail = thumbnail;
      modalRef.componentInstance.content = data;
      modalRef.componentInstance.preview = true;
    }
    this.isPreview = false;
  }

  generatePopOverData(content) {
    // tslint:disable:max-line-length
    let title = 'Content unavailable';
    let message = 'This content isn\'t available at the moment.';
    const diff = moment(content.expiry_date).diff(moment(), 'days');
    const isExpired = diff <= 0;

    if ((content.tokens === 0 || (content.tokens > 0 && !content.purchase_content_before_paid_lib_subscribe)) && (content.content_deteled_by_owner || content.user_plan_expired)) {
      message = 'This content is no longer available.';
    } else if ((content.tokens === 0 || (content.tokens > 0 && !content.purchase_content_before_paid_lib_subscribe)) && (content.user.verification_status === 'rejected' || (content.user.verification && content.user.verification.is_verified && content.user.verification.is_verified === 'rejected'))) {
      message = 'This content isn\'t available at the moment.';
    } else if (content.tokens > 0 && content.paid_library_subscription_expired && content.user.business_pro_plus_user && !content.purchase_content_before_paid_lib_subscribe && (content.user.verification_status !== 'rejected' || (content.user.verification && content.user.verification.is_verified && content.user.verification.is_verified !== 'rejected'))) {
      message = 'Your paid subscription for ' + content.user.business_name + ' has been expired.';
    }  else if (content.tokens > 0 && content.paid_library_subscription_expired && !content.user.business_pro_plus_user && !content.purchase_content_before_paid_lib_subscribe && (content.user.verification_status !== 'rejected' || (content.user.verification && content.user.verification.is_verified && content.user.verification.is_verified !== 'rejected'))) {
      message =  content.user.business_name + 'plan has been upgraded, please buy individually.';
    } else if (content.tokens > 0  && content.purchase_content_before_paid_lib_subscribe && isExpired) {
      if (content.user.verification_status === 'rejected' || (content.user.verification && content.user.verification.is_verified && content.user.verification.is_verified === 'rejected')) {
        message = 'This content isn\'t available at the moment.';
      } else {
        title = 'Content Expired';
        message = 'This content has been expired';
      }
    }

    return {title, message};

  }

}
